// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1XpeT","bigColWidth":"Table_bigColWidth__2jQNl","biggerColWidth":"Table_biggerColWidth__3RTaR","row":"Table_row__3x_4W","col":"Table_col__2M5YX"};